import {
  Box,
  Container,
  Grid,
  Typography,
  CircularProgress,
} from '@mui/material';
import { NextPage } from 'next';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import forgotPasswordImg from 'assets/images/forgotPassword-img.svg';
import { CustomButton, CustomTextField, MetaTags } from 'components/common';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Link from 'components/Link';
import { ApiPostNoAuth } from 'helpers/Api/ApiData';
import { toast, ToastContainer } from 'react-toastify';
import { useRouter } from 'next/router';

const ForgotPassword: NextPage = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const router = useRouter();
  interface FormFields {
    email: string;
  }

  const schema = yup.object().shape({
    email: yup.string().email().required(),
  });

  const {
    handleSubmit,
    // formState: { errors },
    control,
  } = useForm<FormFields>({ mode: 'onTouched', resolver: yupResolver(schema) });

  const onSubmit: SubmitHandler<FormFields> = (data) => {
    setLoader(true);
    ApiPostNoAuth(`user/forgot-password`, data)
      .then((res: any) => {
        if (res.data.statusCode === 200) {
          router.push('/reset-password');
          // toast.success(res.data.message, { autoClose: 5000 ,hideProgressBar: true });
          setLoader(false);
        } else {
          toast.error(res?.data?.message || 'Please try again!!', {
            autoClose: 5000,
            hideProgressBar: true,
          });
          setLoader(false);
        }
      })
      .catch((err) => {
        toast.error(err.message, { autoClose: 5000, hideProgressBar: true });
        setLoader(false);
      });
  };

  return (
    <>
      <MetaTags
        title="Reset Password - POD"
        description="Reset your forgotten password"
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="Startup Fundraising"
      />
      <Container
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
        maxWidth="xl"
      >
        <ToastContainer />
        <Grid container>
          <Grid
            item
            md={6}
            sx={{
              display: {
                xs: 'none',
                md: 'flex',
              },
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={forgotPasswordImg.src}
              alt="forgot password illustration"
            />
          </Grid>
          <Grid item md={1.5} xs={0} />
          <Grid item md={3} xs={12}>
            <Typography
              component="h2"
              color="#111111"
              fontSize={20}
              fontWeight={500}
              mb="20px"
            >
              Forgot Password
            </Typography>
            <Typography
              component="p"
              color="rgba(17, 17, 17, 0.5)"
              fontSize={14}
              fontWeight={400}
              mb="10px"
            >
              Enter your registered Email ID to reset your password
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <CustomTextField
                name="email"
                label="Email ID"
                fullWidth
                control={control}
                variant="outlined"
              />
              <Box display="flex" flexDirection="column" alignItems="center">
                <CustomButton
                  type="submit"
                  sx={{ fontSize: 20, width: 260, height: 60, mt: 2 }}
                  variant="contained"
                >
                  {loader ? (
                    <CircularProgress sx={{ color: 'white', fontSize: 14 }} />
                  ) : (
                    'Confirm'
                  )}
                </CustomButton>
                <Link
                  href="/login"
                  sx={{
                    textDecoration: 'none',
                    color: 'rgba(17, 17, 17, 0.7)',
                    fontSize: 14,
                    mt: 2,
                  }}
                >
                  Cancel
                </Link>
              </Box>
            </form>
            {/* <img src={forgotPasswordImg.src} alt="forgot password illustration" /> */}
          </Grid>
          <Grid item md={1.5} xs={0} />
        </Grid>
      </Container>
    </>
  );
};

export default ForgotPassword;
